import { PermissionStatus } from 'expo-tracking-transparency';

import noop from 'utils/noop';

export const updateMParticleATTStatus = noop as (status: PermissionStatus) => void;
